export default __webpack_public_path__ + "static/media/dozule9.ac0f5dd3.jpg";